<template>
  <div class="tooltip-box flex items-center justify-center">
    <p
      role="status"
      aria-live="polite"
      class="tooltip-box__title ml-2"
      tabindex="0"
    >
      {{ text }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useLiveAnnouncer } from "@/services/composables/useLiveAnnouncer";
import { onMounted } from "vue";

const props = defineProps({
  text: {
    type: String,
    default: "",
  },
});

onMounted(() => {
  // Ensure the text will be read by assistive technologies
  useLiveAnnouncer.announce("politeStatus", props.text);
});
</script>

<style lang="scss" scoped>
@use "@/assets/styles/variables.scss" as *;

.tooltip-box {
  position: absolute;
  width: 200px;
  min-height: 50px;
  left: min(calc(100% - 200px), calc(var(--tooltip-position-x) - 100px));
  top: calc(var(--tooltip-position-y) + 25px);
  color: var(--DM__theme-font-color);
  background-color: var(--DM__theme-fill-color);
  box-shadow: 0 4px 23px rgba(0, 0, 0, 0.09);
  border: 3px solid rgba(158, 158, 158, 0.2);
  padding: $spacingS $spacingM;
  z-index: 5;
  p {
    margin: 0;
    text-align: center;
    font-size: 0.9rem;
  }
}
</style>
